/*
  Canonical WallStreetMojo landing-page preview/media runtime.
  Batch 11C preserves the existing modal, playlist, thumbnail, and close
  behavior while giving it one guarded owner across landing and catalogue
  surfaces. Pricing, offers, CTA, checkout, popup, tracking, search, geo,
  social proof, and layout remain outside this asset.
*/

(function () {
  "use strict";
  if (window.__wsmLandingPreviewRuntimeV1) return;
  window.__wsmLandingPreviewRuntimeV1 = true;
  var modal = document.getElementById("videoPreviewModal");
  var frame = document.getElementById("videoPreviewFrame");
  var titleEl = document.getElementById("videoPreviewTitle");
  var metaEl = document.getElementById("videoPreviewMeta");
  var playlistEl = document.getElementById("videoPreviewPlaylist");
  var countEl = document.getElementById("videoPreviewCount");
  var closeButtons = Array.prototype.slice.call(document.querySelectorAll("[data-preview-close]"));
  var fallbackPreviewSrc = "https://player.vimeo.com/video/1185864839?autoplay=1&muted=0&loop=0&background=0&controls=1&title=0&byline=0&portrait=0&badge=0&autopause=0#t=0s";
  var playlist = [];
  var activeIndex = 0;
  var previewThumbnailCache = {};

  function text(value, fallback) {
    value = value == null ? "" : String(value).trim();
    return value || fallback || "";
  }

  function escapeHtml(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[char];
    });
  }

  function addPreviewParams(url) {
    if (!url) return fallbackPreviewSrc;
    var cleaned = String(url).trim();
    var hash = "";
    var hashIndex = cleaned.indexOf("#");
    if (hashIndex > -1) {
      hash = cleaned.slice(hashIndex);
      cleaned = cleaned.slice(0, hashIndex);
    }
    function addParam(name, value) {
      if (cleaned.indexOf(name + "=") !== -1) return;
      cleaned += (cleaned.indexOf("?") === -1 ? "?" : "&") + name + "=" + value;
    }
    addParam("autoplay", "1");
    addParam("controls", "1");
    addParam("title", "0");
    addParam("byline", "0");
    addParam("portrait", "0");
    return cleaned + hash;
  }

  function normalizePreviewUrl(url) {
    if (!url) return fallbackPreviewSrc;
    var cleaned = String(url).trim();
    var youtubeId = "";
    var vimeoId = "";
    try {
      var parsed = new URL(cleaned, window.location.origin);
      var host = parsed.hostname.replace(/^www\./, "");
      if (host === "youtube.com" || host === "m.youtube.com") {
        if (parsed.pathname.indexOf("/embed/") === 0) youtubeId = parsed.pathname.split("/embed/")[1].split("/")[0];
        else if (parsed.pathname.indexOf("/shorts/") === 0) youtubeId = parsed.pathname.split("/shorts/")[1].split("/")[0];
        else youtubeId = parsed.searchParams.get("v") || "";
      } else if (host === "youtu.be") {
        youtubeId = parsed.pathname.replace(/^\//, "").split("/")[0];
      } else if (host === "player.vimeo.com" && parsed.pathname.indexOf("/video/") === 0) {
        vimeoId = parsed.pathname.split("/video/")[1].split("/")[0];
      } else if (host.indexOf("vimeo.com") !== -1) {
        var match = cleaned.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
        if (match && match[1]) vimeoId = match[1];
      }
    } catch (e) {
      var ytMatch = cleaned.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
      var viMatch = cleaned.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (ytMatch && ytMatch[1]) youtubeId = ytMatch[1];
      if (viMatch && viMatch[1]) vimeoId = viMatch[1];
    }
    if (youtubeId) return addPreviewParams("https://www.youtube.com/embed/" + encodeURIComponent(youtubeId) + "?rel=0&modestbranding=1");
    if (vimeoId) return addPreviewParams("https://player.vimeo.com/video/" + encodeURIComponent(vimeoId));
    return addPreviewParams(cleaned);
  }

  function getInlineThumb(node) {
    if (!node) return "";
    var explicit = node.getAttribute("data-preview-thumb");
    if (explicit) return explicit;
    var img = node.querySelector ? node.querySelector("img") : null;
    if (img && img.currentSrc) return img.currentSrc;
    if (img && img.src) return img.src;
    var bg = window.getComputedStyle ? window.getComputedStyle(node).backgroundImage : "";
    var match = bg && bg.match(/url\(["']?([^"')]+)["']?\)/);
    return match && match[1] ? match[1] : "";
  }

  function extractVimeoId(url) {
    url = text(url);
    if (!url) return "";
    var match = url.match(/vimeo\.com\/(?:video\/)?(?:.*\/)?(\d{6,})/);
    return match && match[1] ? match[1] : "";
  }

  function applyPreviewThumb(node, thumbUrl) {
    if (!node || !thumbUrl) return;
    node.setAttribute("data-preview-thumb", thumbUrl);
    if (node.style && node.classList) {
      node.style.setProperty("--wsm-preview-thumb-url", 'url("' + String(thumbUrl).replace(/"/g, '%22') + '")');
      node.classList.add("has-preview-thumb");
    }
    if (node.classList && node.classList.contains("wsm-video-testimonial-thumb") && !node.querySelector("img")) {
      var img = document.createElement("img");
      img.src = thumbUrl;
      img.alt = node.getAttribute("aria-label") || "Video thumbnail";
      img.loading = "lazy";
      var first = node.firstChild;
      if (first) node.insertBefore(img, first); else node.appendChild(img);
    }
  }

  function fetchVimeoThumbnailForNode(node) {
    if (!node || text(node.getAttribute("data-preview-thumb"))) return;
    var url = text(node.getAttribute("data-preview-url"));
    var vimeoId = extractVimeoId(url);
    if (!vimeoId) return;
    if (previewThumbnailCache[url]) {
      applyPreviewThumb(node, previewThumbnailCache[url]);
      return;
    }
    if (!window.fetch) return;
    window.fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(url), { mode: "cors" })
      .then(function (res) { return res && res.ok ? res.json() : null; })
      .then(function (data) {
        var thumb = data && (data.thumbnail_url || data.thumbnail_url_with_play_button);
        if (!thumb) return;
        previewThumbnailCache[url] = thumb;
        Array.prototype.slice.call(document.querySelectorAll("[data-preview-open]")).forEach(function (sameNode) {
          if (text(sameNode.getAttribute("data-preview-url")) === url) applyPreviewThumb(sameNode, thumb);
        });
        if (modal && modal.classList && modal.classList.contains("is-open") && playlist && playlist.length) {
          var changed = false;
          playlist.forEach(function (item) {
            if (text(item.url) === url && !item.thumb) {
              item.thumb = thumb;
              changed = true;
            }
          });
          if (changed) {
            renderPlaylist();
            queueActivePlaylistScroll();
          }
        }
      })
      .catch(function () {});
  }

  function schedulePreviewThumbnailHydration() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll("[data-preview-open]")).filter(function (node) {
      return !text(node.getAttribute("data-preview-thumb")) && extractVimeoId(node.getAttribute("data-preview-url"));
    });
    if (!nodes.length) return;
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          fetchVimeoThumbnailForNode(entry.target);
        });
      }, { rootMargin: "300px 0px" });
      nodes.forEach(function (node) { observer.observe(node); });
    } else {
      window.setTimeout(function () { nodes.slice(0, 8).forEach(fetchVimeoThumbnailForNode); }, 900);
    }
  }

  function hasAny(value, words) {
    value = text(value).toLowerCase();
    return words.some(function (word) { return value.indexOf(word) !== -1; });
  }

  function looksLikeCourseSnapshot(type, title, description, index) {
    var raw = text(type).toLowerCase();
    var combined = [raw, title, description].join(" ").toLowerCase();
    return parseInt(index, 10) === 0 || hasAny(combined, ["marketing video", "course snapshot", "course preview", "course overview", "snapshot"]);
  }

  function looksLikeSample(type, title, description) {
    var raw = text(type).toLowerCase();
    var combined = [raw, title, description].join(" ").toLowerCase();
    if (hasAny(raw, ["sample", "lesson", "intro video", "intro", "ai workflow", "modeling case", "modelling case", "dcf preview", "course module", "chapter", "tutorial", "demo"])) return true;
    return hasAny(combined, ["part ", "quick demo", "getting started", "advanced formulas", "data analysis", "excel macros", "course cover", "what does the course cover", "walkthrough", "case study", "modeling", "modelling", "valuation", "dcf", "lesson"]);
  }

  function looksLikeTestimonial(type, title, description) {
    var raw = text(type).toLowerCase();
    var combined = [title, description].join(" ").toLowerCase();
    if (hasAny(raw, ["testimonial", "student story", "student stories", "success story", "learner story"])) return true;
    if (hasAny(raw, ["review"]) && !looksLikeSample(type, title, description)) return true;
    return hasAny(combined, ["testimonial", "student story", "student stories", "success story", "learner story"]);
  }

  function normalizeDisplayType(type, index, title, description) {
    var raw = text(type);
    if (looksLikeCourseSnapshot(raw, title, description, index)) return "Course Snapshot";
    // Testimonials must be checked before sample lessons because testimonial titles can
    // contain words like "Excel", "Part", "lesson", or "case".
    if (looksLikeTestimonial(raw, title, description)) return "Testimonial";
    if (looksLikeSample(raw, title, description)) return "Sample Lesson";
    if (hasAny(raw, ["bonus"])) return "Bonus Preview";
    return raw || "Sample Lesson";
  }

  function normalizeExplicitGroup(group) {
    var raw = text(group);
    var lower = raw.toLowerCase();
    if (!raw) return "";
    if (lower.indexOf("course snapshot") !== -1 || lower.indexOf("marketing") !== -1 || lower.indexOf("course preview") !== -1 || lower.indexOf("overview") !== -1) return "Course Snapshot";
    if (lower.indexOf("testimonial") !== -1 || lower.indexOf("student story") !== -1 || lower.indexOf("success story") !== -1 || lower.indexOf("review") !== -1) return "Testimonials";
    if (lower.indexOf("sample") !== -1 || lower.indexOf("lesson") !== -1 || lower.indexOf("free") !== -1) return "Free Sample Videos";
    if (lower.indexOf("bonus") !== -1) return "Bonus Previews";
    return raw;
  }

  function getGroupLabel(item) {
    var explicitGroup = normalizeExplicitGroup(item.group);
    if (explicitGroup) return explicitGroup;
    if (item.displayType === "Course Snapshot" || looksLikeCourseSnapshot(item.type, item.title, item.description, item.index)) return "Course Snapshot";
    if (item.displayType === "Testimonial" || looksLikeTestimonial(item.type, item.title, item.description)) return "Testimonials";
    if (item.displayType === "Sample Lesson" || looksLikeSample(item.type, item.title, item.description)) return "Free Sample Videos";
    if (item.displayType === "Bonus Preview" || hasAny(item.type, ["bonus"])) return "Bonus Previews";
    return "Free Sample Videos";
  }

  function groupClass(group) {
    return "wsm-preview-group-" + text(group, "other").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }

  function groupPriority(group) {
    group = text(group).toLowerCase();
    if (group.indexOf("course snapshot") !== -1) return 0;
    if (group.indexOf("free sample") !== -1 || group.indexOf("sample") !== -1) return 1;
    if (group.indexOf("testimonial") !== -1 || group.indexOf("student") !== -1) return 2;
    if (group.indexOf("bonus") !== -1) return 3;
    return 4;
  }

  function nodeSignature(node) {
    if (!node) return "";
    return [
      text(node.getAttribute("data-preview-url")),
      text(node.getAttribute("data-preview-title")),
      text(node.getAttribute("data-preview-duration"))
    ].join("|").toLowerCase();
  }

  function itemSignature(item) {
    if (!item) return "";
    return [text(item.url), text(item.title), text(item.duration)].join("|").toLowerCase();
  }

  function collectPlaylist() {
    var rawNodes = Array.prototype.slice.call(document.querySelectorAll("[data-preview-open]")).filter(function (node) {
      return text(node.getAttribute("data-preview-url")) || text(node.getAttribute("data-preview-title"));
    });
    var seen = {};
    var items = [];
    rawNodes.forEach(function (node, order) {
      // Parent cards and nested play buttons can both carry data-preview-open. Keep only one copy.
      var signature = nodeSignature(node) || ("order-" + order);
      if (seen[signature]) return;
      seen[signature] = true;

      var rawIndex = parseInt(node.getAttribute("data-preview-index"), 10);
      var index = isNaN(rawIndex) ? order : rawIndex;
      var itemUrl = text(node.getAttribute("data-preview-url"), fallbackPreviewSrc);
      var itemThumb = text(getInlineThumb(node), "") || text(previewThumbnailCache[itemUrl], "");
      var item = {
        node: node,
        index: index,
        sourceOrder: order,
        url: itemUrl,
        title: text(node.getAttribute("data-preview-title"), index === 0 ? "Course Preview" : "Sample Lesson"),
        type: text(node.getAttribute("data-preview-type"), index === 0 ? "Course Snapshot" : "Sample Lesson"),
        duration: text(node.getAttribute("data-preview-duration"), index === 0 ? "Course Preview" : "Preview"),
        description: text(node.getAttribute("data-preview-description"), ""),
        thumb: itemThumb,
        group: text(node.getAttribute("data-preview-group"), "")
      };
      item.displayType = normalizeDisplayType(item.type, item.index, item.title, item.description);
      item.group = getGroupLabel(item);
      item.groupClass = groupClass(item.group);
      item.sortPriority = groupPriority(item.group);
      item.signature = itemSignature(item);
      items.push(item);
    });
    playlist = items.sort(function (a, b) {
      if (a.sortPriority !== b.sortPriority) return a.sortPriority - b.sortPriority;
      if (a.index !== b.index) return a.index - b.index;
      return a.sourceOrder - b.sourceOrder;
    });
    if (!playlist.length) {
      playlist = [{ index: 0, sourceOrder: 0, sortPriority: 0, url: fallbackPreviewSrc, title: "Course Preview", type: "Course Snapshot", displayType: "Course Snapshot", group: "Course Snapshot", groupClass: "wsm-preview-group-course-snapshot", duration: "Course Preview", description: "", thumb: "", signature: "" }];
    }
    if (countEl) countEl.textContent = playlist.length + " video" + (playlist.length === 1 ? "" : "s");
    return playlist;
  }

  function findPositionByTrigger(trigger) {
    if (trigger) {
      // Most reliable: match the exact DOM trigger collected into the playlist.
      // This fixes cases where testimonials only had a URL earlier and therefore
      // failed signature matching, causing every click to start at Course Snapshot.
      for (var n = 0; n < playlist.length; n += 1) {
        if (playlist[n].node === trigger) return n;
      }
      var sig = nodeSignature(trigger);
      if (sig) {
        for (var s = 0; s < playlist.length; s += 1) {
          if (playlist[s].signature === sig) return s;
          if (text(playlist[s].url).toLowerCase() === text(trigger.getAttribute("data-preview-url")).toLowerCase() && text(trigger.getAttribute("data-preview-url"))) return s;
        }
      }
      var numeric = parseInt(trigger.getAttribute("data-preview-index"), 10);
      if (!isNaN(numeric)) {
        for (var i = 0; i < playlist.length; i += 1) {
          if (playlist[i].index === numeric) return i;
        }
      }
    }
    return 0;
  }

  function renderPlaylist() {
    if (!playlistEl) return;
    var previousGroup = "";
    playlistEl.innerHTML = playlist.map(function (item, position) {
      var groupMarkup = "";
      if (item.group !== previousGroup) {
        previousGroup = item.group;
        groupMarkup = '<div class="wsm-preview-playlist-group-title ' + escapeHtml(item.groupClass) + '"><span>' + escapeHtml(item.group) + '</span></div>';
      }
      var active = position === activeIndex ? " is-active" : "";
      var itemClass = item.groupClass ? " " + item.groupClass : "";
      var thumb = item.thumb ? '<span class="wsm-preview-playlist-thumb has-preview-thumb" style="--wsm-preview-thumb-url:url(&quot;' + escapeHtml(item.thumb) + '&quot;)"><span>▶</span></span>' : '<span class="wsm-preview-playlist-thumb"><span>▶</span></span>';
      return groupMarkup + '<button type="button" class="wsm-preview-playlist-item' + active + itemClass + '" data-preview-playlist-position="' + position + '">' +
        thumb +
        '<span class="wsm-preview-playlist-copy"><small>' + escapeHtml(item.displayType || item.type) + '</small><strong>' + escapeHtml(item.title) + '</strong></span>' +
        '<em>' + escapeHtml(item.duration) + '</em>' +
      '</button>';
    }).join("");
  }

  function getPlaylistScrollContainer(activeItem) {
    if (!playlistEl) return null;

    // V108.7: prefer the playlist itself when CSS makes it the scrollable area.
    // Older V108 builds used the outer playlist wrapper as the scroll area, so we
    // keep both paths for backwards compatibility.
    var candidates = [];
    candidates.push(playlistEl);
    var wrap = playlistEl.closest ? playlistEl.closest(".wsm-preview-playlist-wrap") : null;
    if (wrap) candidates.push(wrap);
    var main = playlistEl.closest ? playlistEl.closest(".wsm-preview-modal-main") : null;
    if (main) candidates.push(main);

    var parent = activeItem ? activeItem.parentElement : null;
    while (parent && parent !== modal && parent !== document.body) {
      if (candidates.indexOf(parent) === -1) candidates.push(parent);
      parent = parent.parentElement;
    }

    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;
      if ((node.scrollHeight || 0) > (node.clientHeight || 0) + 4) return node;
    }
    return wrap || playlistEl;
  }

  function scrollActivePlaylistItem() {
    if (!playlistEl) return false;
    var activeItem = playlistEl.querySelector ? playlistEl.querySelector(".wsm-preview-playlist-item.is-active") : null;
    if (!activeItem) return false;

    var scrollWrap = getPlaylistScrollContainer(activeItem);
    if (!scrollWrap) return false;

    var maxScroll = Math.max(0, (scrollWrap.scrollHeight || 0) - (scrollWrap.clientHeight || 0));
    if (!maxScroll) return false;

    var wrapRect = scrollWrap.getBoundingClientRect();
    var activeRect = activeItem.getBoundingClientRect();
    var currentTop = scrollWrap.scrollTop || 0;

    // If the outer wrapper is scrolling, keep the active item below the sticky
    // playlist header. If the inner playlist is scrolling, there is no sticky
    // header inside that scroll area.
    var stickyHead = scrollWrap.querySelector && scrollWrap !== playlistEl ? scrollWrap.querySelector(".wsm-preview-playlist-head") : null;
    var stickyOffset = stickyHead ? stickyHead.offsetHeight : 0;

    // Put the currently playing item near the top of the visible playlist so a
    // testimonial/sampled lesson opened from the page is immediately visible.
    var targetTop = currentTop + (activeRect.top - wrapRect.top) - stickyOffset - 12;
    var nextTop = Math.max(0, Math.min(maxScroll, targetTop));

    // Set scrollTop directly first. This is more reliable than smooth scrolling
    // while the modal, iframe, and right panel are still settling.
    scrollWrap.scrollTop = nextTop;

    // Small verification pass: if the item is still not visible, center it.
    var updatedWrapRect = scrollWrap.getBoundingClientRect();
    var updatedActiveRect = activeItem.getBoundingClientRect();
    var stillAbove = updatedActiveRect.top < updatedWrapRect.top + stickyOffset + 6;
    var stillBelow = updatedActiveRect.bottom > updatedWrapRect.bottom - 6;
    if (stillAbove || stillBelow) {
      var centeredTop = scrollWrap.scrollTop + (updatedActiveRect.top - updatedWrapRect.top) - (scrollWrap.clientHeight / 2) + (activeItem.offsetHeight / 2);
      scrollWrap.scrollTop = Math.max(0, Math.min(maxScroll, centeredTop));
    }
    return true;
  }

  function queueActivePlaylistScroll() {
    if (!playlistEl) return;
    var run = function () { scrollActivePlaylistItem(); };

    // Run several times because Shopify/Vimeo/YouTube iframes and the modal grid
    // can settle a little after the first paint. This fixes lower testimonial
    // clicks where the playlist previously stayed at the top.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
      window.requestAnimationFrame(function () { window.requestAnimationFrame(run); });
    } else {
      run();
    }
    [60, 140, 280, 520, 900].forEach(function (delay) {
      window.setTimeout(run, delay);
    });
  }

  function loadItem(position) {
    if (!frame || !playlist.length) return;
    activeIndex = Math.max(0, Math.min(position || 0, playlist.length - 1));
    var item = playlist[activeIndex];
    var src = normalizePreviewUrl(item.url);
    if (titleEl) titleEl.textContent = item.title || "Course Preview";
    if (metaEl) {
      var meta = [item.group || item.displayType, item.duration].filter(Boolean).join(" · ");
      metaEl.textContent = meta || "Course Preview";
    }
    frame.innerHTML = '<iframe src="' + src + '" title="' + escapeHtml(item.title || "Course preview video") + '" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
    renderPlaylist();
    queueActivePlaylistScroll();
    var activeFrame = frame.querySelector ? frame.querySelector("iframe") : null;
    if (activeFrame) activeFrame.addEventListener("load", queueActivePlaylistScroll, { once: true });
  }

  function openPreview(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!modal || !frame) return;
    var trigger = event && event.currentTarget ? event.currentTarget : null;
    collectPlaylist();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("video-modal-open");
    loadItem(findPositionByTrigger(trigger));
  }

  function closePreview() {
    if (!modal || !frame) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("video-modal-open");
    frame.innerHTML = "";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedulePreviewThumbnailHydration, { once: true });
  } else {
    schedulePreviewThumbnailHydration();
  }

  document.addEventListener("click", function (event) {
    var openButton = event.target.closest ? event.target.closest("[data-preview-open]") : null;
    if (openButton) {
      openPreview({ preventDefault: function(){ event.preventDefault(); }, stopPropagation: function(){ event.stopPropagation(); }, currentTarget: openButton });
      return;
    }
    var playlistButton = event.target.closest ? event.target.closest("[data-preview-playlist-position]") : null;
    if (playlistButton) {
      event.preventDefault();
      loadItem(parseInt(playlistButton.getAttribute("data-preview-playlist-position"), 10) || 0);
    }
  });

  closeButtons.forEach(function (button) { button.addEventListener("click", closePreview); });
  if (modal) modal.addEventListener("click", function (event) { if (event.target === modal) closePreview(); });
  document.addEventListener("keydown", function (event) { if (event.key === "Escape") closePreview(); });
})();
